import React, { Component } from 'react';
import _ from 'lodash';

export class InputConfirmation extends Component {

    constructor(props) {
        super(props);
        this.navOutTimeout = null;
    }

    componentDidMount() {
        this.navOutTimeout = setTimeout(() => {
            this.navOut();
            this.navOutTimeout = null
        }, 10000)
    }

    componentDidUpdate() {

    }

    componentWillUnmount() {
        clearTimeout(this.navOutTimeout);
        this.navOutTimeout = null
    }

    navOut() {
        this.props.navback()
    }

    render() {

        return (

            <div>
                <div style={{ position: 'fixed', textAlign: 'center', left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: this.props.screen.screenHeight }}>
                    <div style={{ height: '100%' }} className="aligner">
                        <div className="aligner-item" style={{fontSize: this.props.screen.r16_9.p10*.6}}>
                            {this.props.module.contents.inputConfirmation}
                        </div>
                    </div>
                </div>
            </div>


        );
    }
}

export default InputConfirmation;






// WEBPACK FOOTER //
// ./src/Components/UserInput/InputConfirmation.js